import Link from 'next/link'

export default function Breadcrumb({currentPage }) {
   return (
      <>
         <div className="d-flex justify-content-center align-items-baseline gap-1 breadcrumb">
            <Link href="/">Home</Link>
            <img src="/assets/svg/case-study/two-arrow-right.svg" />
            <p className="cs-font-medium">{currentPage}</p>
         </div>
      </>
   )
}
